import axios from "axios";
import { cmsHeaders } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchNewsLetterBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/newsletters-banner`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const fetchNewsLetterData = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/newsletters-newsletter`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error) {
    dynamicFailed("Server Error");
  }
};
